<template>
  <app-preloader v-if="!isLoaded"/>
  <component
    v-else
    :is="layout"
  >
    <router-view />
  </component>
  <app-toast />
  <app-alert-import />
</template>

<script>
import "external-svg-loader";
import WorkspaceMainLayout from "@/components/layouts/WorkspaceMainLayout.vue";
import AuthMainLayout from "@/components/layouts/AuthMainLayout.vue";
import AppToast from "./components/UI/AppToast/AppToast.vue";
import AppAlertImport from "@/components/UI/AppAlertImport/AppAlertImport.vue";
import AppPreloader from "@/components/workspace/AppPreloader.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    AppPreloader,
    AppToast,
    AppAlertImport,
    WorkspaceMainLayout,
    AuthMainLayout,
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapGetters(['authUser']),
    layout() {
      return this.$route.meta.layout;
    },
  },
  methods: {
    ...mapActions(["getAuthUser", "checkImportLogs"]),
    checkLogImportTimer() {
      setInterval(() => {
        if (this.$store.state?.importInfo?.stateImportInfo) {
          this.checkImportLogs()
          .then((res) => {
            if (!res?.length) {
              this.$store.commit('setStateImportInfo', false)
            }
          })
          .catch((err) => {
            this.$store.commit('setStateImportInfo', false)
          })
        }
      }, 2500)
    },
  },
  created () {
    if (location.pathname == '/auth/signin') {
      this.isLoaded = true;
      return;
    }

    this.getAuthUser()
        .then((user) => {

          if(['respondent','expert'].includes(user?.role?.slug) && user.account_design){
            if(user?.account_design?.buttonColor){
            document.body.style.setProperty('--theme-color-button', user.account_design.buttonColor)
            document.body.style.setProperty('--theme-color-font', user.account_design.fontColor)
            }
          }

          if(this.authUser.registrationStep !== null) {
            this.$router.push({
              name: 'FinishSignup'
            })
          }

          if(this.$route.meta?.role && this.$route.meta?.role !== user.role?.slug) {
            this.$router.push('/')
          }
        })
        .finally(() => {
          this.isLoaded = true;
          this.checkLogImportTimer();
        })
  }
};
</script>


<style lang="scss" src="./assets/scss/app.scss"/>
<style lang="scss" src="./assets/scss/mobile.scss"/>
